import React from "react";

import { Error } from "components/DetailedSaleLotModal/AdvancedDrafting/components";
import { withNamespace } from "components/Form/FormikControls";
import { ExportSite } from "constants/exportSites";

export const TimeUnitChoices = [
  {
    value: "months",
    label: "Months",
  },
  {
    value: "years",
    label: "Years",
  },
];

export const allocationDiffErrorMessage = (number: number): JSX.Element =>
  typeof number === "number" && number ? (
    <Error>
      {Math.abs(number)} {number > 0 ? "under" : "over"}
    </Error>
  ) : null;

export const withAttributeNamespace = (name: string, namespace = "") =>
  withNamespace(namespace, withNamespace("draftingAttributes", name));

// Show full drafting unless Stocklive is the only export site
export const enableFullDrafting = (exportSites?: string[] | null): boolean =>
  Array.isArray(exportSites)
    ? !exportSites.every(site => site === ExportSite.STOCK_LIVE) ||
      exportSites.length === 0
    : true;
